import type { FieldValues } from "react-hook-form";

import { FormField, FormItem } from "@/components/ui/form";
import { cn } from "@/lib/utils";

import BaseSelectOptions from "./BaseSelectOptions";
import type { SelectOptionsProps } from "./types";

interface SelectOptionsUnifiedProps<T extends FieldValues>
  extends SelectOptionsProps<T> {
  withValidation?: boolean;
  validationMessage?: string;
}

const SelectOptionsWithValidation = <T extends FieldValues>({
  selectList,
  title,
  form,
  name,
  withValidation = false,
  validationMessage = "Choose at least 1",
}: SelectOptionsUnifiedProps<T>) => (
  <FormField
    control={form}
    name={name}
    render={({ field }) => {
      const selected: string[] = field.value ?? [];
      const isValid = !withValidation || selected.length > 0;

      return (
        <FormItem className={cn("gap-3.5 relative")}>
          <div className="text-sm text-gray-950 font-bold">{title}</div>

          {withValidation && (
            <p
              className={cn(
                "absolute top-4 left-0 mb-3 text-xs",
                isValid ? "text-gray-400" : "text-red-500"
              )}
            >
              {validationMessage}
            </p>
          )}

          <BaseSelectOptions
            selectList={selectList}
            selected={selected}
            onChange={field.onChange}
          />
        </FormItem>
      );
    }}
  />
);

export default SelectOptionsWithValidation;
